<template>
    <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
      <span v-if="typ == 'Zahnarzt'">
        Zahnarzt erfassen
      </span>
            <span v-else-if="typ == 'Patient'">
        Patient erfassen
      </span>
            <span v-else>
        neue Adresse erfassen
      </span>
        </v-card-title>

        <v-card-text>
            <v-form
                    @keyup.native.enter="adresseSpeichern()"
                    ref="form"
                    autocomplete="off"
            >
                <v-container grid-list-md>
                    <v-layout>
                        <v-flex md2>
                            <v-select
                                    label="Anrede"
                                    :items="['Herr', 'Frau']"
                                    v-model="adresse.anrede"
                                    data-vv-name="adresse.anrede"
                                    data-vv-as="Anrede"
                            ></v-select>
                        </v-flex>
                        <v-flex md2 v-if="typ == 'Zahnarzt'">
                            <v-text-field
                                    label="Titel"
                                    v-model="adresse.titel"
                            ></v-text-field>
                        </v-flex>
                        <v-flex md4>
                            <v-text-field
                                    label="Vorname"
                                    v-model="adresse.vorname"
                                    data-vv-name="adresse.vorname"
                                    data-vv-as="Vorname"
                            ></v-text-field>
                        </v-flex>
                        <v-flex md4>
                            <v-text-field
                                    ref="nachname"
                                    label="Nachname"
                                    v-model="adresse.nachname"
                                    data-vv-name="adresse.nachname"
                                    data-vv-as="Nachname"
                                    v-validate="'required'"
                                    :error-messages="errors.collect('adresse.nachname')"
                            ></v-text-field>
                        </v-flex>
                        <v-flex md4>
                            <v-text-field
                                    label="Ort"
                                    v-model="adresse.ort"
                                    data-vv-name="adresse.ort"
                                    data-vv-as="Ort"
                            ></v-text-field>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-form>
        </v-card-text>

        <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="black darken-5" flat="flat" @click="$emit('close')">
                Abbrechen
            </v-btn>

            <v-btn
                    color="success"
                    flat="flat"
                    type="submit"
                    @click="adresseSpeichern"
            >
                Speichern
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script type="text/babel">
    export default {
        props: {
            dialog: Boolean,
            typ: {
                type: String,
                default: ""
            },
            val: {
                type: String,
                default: ""
            }
        },
        data() {
            return {
                adresse: {
                    anrede: null,
                    titel: null,
                    vorname: null,
                    nachname: this.val,
                    ort: null,
                    typ: this.typ
                }
            };
        },
        mounted() {
        },
        watch: {
            dialog() {
                if (this.dialog) {
                    // this.$refs.form.reset();
                    this.$validator.reset();
                    setTimeout(() => {
                        this.$refs.nachname.focus();
                    }, 500);

                    Object.assign(this.adresse, this.$options.data.call(this).adresse);
                }
            }
        },
        methods: {
            adresseSpeichern() {
                this.$validator.validateAll().then(valid => {
                    if (!valid) return;
                    this.$store.dispatch("addAdresse", this.adresse).then(() => {
                        this.$emit("neueAdresse", this.adresse);
                    });
                });
            }
        }
    };
</script>
